import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Sparkles, ArrowRight } from "lucide-react";
import SEO, { breadcrumbSchema } from "@/components/SEO";

export default function OccasionPage() {
    const { slug } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const r = await api.get(`/seo/occasions/${slug}`);
                setData(r.data);
                window.scrollTo({ top: 0 });
            } catch { setData({ notFound: true }); }
        })();
    }, [slug]);

    if (!data) return <div className="py-20 text-center text-[#6C6F7A]">Loading…</div>;
    if (data.notFound) return <div className="py-20 text-center">Occasion not found</div>;

    return (
        <div>
            <SEO
                title={data.title}
                description={data.subtitle || `Curated gift card ideas for ${slug}. Instant WhatsApp delivery from 270+ premium Indian brands on LoyltyKart.`}
                path={`/gifts/${slug}`}
                keywords={`${slug} gifts, ${slug} gift cards, best ${slug} gift ideas india, ${slug} voucher`}
                structuredData={breadcrumbSchema([
                    { name: "Home", path: "/" },
                    { name: "Occasions", path: "/" },
                    { name: data.title || slug, path: `/gifts/${slug}` },
                ])}
            />
            <section className="rk-noise relative rk-gradient-gold text-white overflow-hidden">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 py-14 md:py-24 relative z-10">
                    <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-md px-3 py-1.5 rounded-full text-xs uppercase tracking-[0.22em] mb-4">
                        <Sparkles className="w-3.5 h-3.5" /> {data.tagline}
                    </div>
                    <h1 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight mb-4 max-w-3xl">
                        {data.title}
                    </h1>
                    <p className="max-w-2xl text-white/85 text-base md:text-lg leading-relaxed">
                        {data.subtitle}
                    </p>
                </div>
            </section>

            <section className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 py-10">
                <div className="mb-6">
                    <div className="text-xs uppercase tracking-[0.22em] text-[#6C6F7A] mb-2">Curated picks</div>
                    <h2 className="font-serif text-3xl md:text-4xl">Best {data.slug} gift cards</h2>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {data.brands.map((b) => <ProductCard key={b.id} brand={b} />)}
                </div>
            </section>

            <section className="max-w-[1400px] mx-auto px-4 md:px-8 lg:px-12 py-10 border-t border-[#E5E0D5]">
                <h3 className="font-serif text-2xl mb-4">Also explore</h3>
                <div className="flex flex-wrap gap-2">
                    {["birthday","anniversary","wedding","diwali","rakhi","corporate"].filter(s => s !== slug).map(s => (
                        <Link key={s} to={`/gifts/${s}`}
                            className="rk-btn-ghost text-sm capitalize">
                            {s} <ArrowRight className="inline w-3 h-3 ml-1" />
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
